import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/modals/wallet/deposit';
import {setPreset} from '../../../../../reducers/wallet/actions';
import {changeCoin} from '../../../../../reducers/wallet/actions/crypto_deposit';
import Tokens from './tokens';
import MethodPrediction from '../../../../../utils/method_prediction';

import {useEffect} from 'react';
import Triggers from '../../../../../lib/triggers';

export default ({setTab}) => {
    const {voucher, deposit_bonus} = useSelector(Selector),
          dispatch = useDispatch();

    const onTokenClick = tokenData => {
        dispatch(changeCoin(tokenData));

        dispatch(setPreset({
            mode: "methods",
            method: "crypto-deposit"
        }));
    }

    useEffect(() => {
        Triggers.modal_open({
            modal: "wallet",
            tab: "deposit_crypto"
        });
    }, []);

    const getMethodPredictionBonus = (method, bonus) => {
        if(!bonus)
            return 0;

        if(bonus.type === "voucher") {
            if(bonus.details.method_prediction === "all")
                return bonus.details.bonus;

            if(bonus.details.method_prediction === "chime_only")
                return ['chime'].includes(method) ? bonus.details.bonus : 0;

            if(bonus.details.method_prediction === "cashapp_only")
                return ['cashapp'].includes(method) ? bonus.details.bonus : 0;

            if(bonus.details.method_prediction === "cashapp_chime")
                return ['chime', 'cashapp'].includes(method) ? bonus.details.bonus : 0;

            if(bonus.details.method_prediction === "crypto")
                return ['crypto'].includes(method) ? bonus.details.bonus : 0;
        }

        if(bonus.type === "boost")
            return bonus.details.bonus;

        return 0;
    }

    return (
        <>
            {voucher && (
                <div className="bonus-message">
                    <div className="icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.16665 5.16666H7.99998C7.92149 5.16346 7.84481 5.14206 7.77601 5.10414C7.70721 5.06622 7.64817 5.01282 7.60356 4.94816C7.55894 4.8835 7.52997 4.80935 7.51894 4.73157C7.5079 4.65379 7.51511 4.57451 7.53998 4.49999C7.77332 3.91332 7.98665 3.31332 8.15998 2.72666C8.30665 2.27332 8.87998 0.853323 10.32 0.853323C10.8812 0.835339 11.4266 1.04074 11.8366 1.42444C12.2465 1.80814 12.4875 2.33881 12.5066 2.89999C12.5066 4.18666 11.0466 4.71332 10.5066 4.89999C9.74321 5.09921 8.95534 5.18899 8.16665 5.16666ZM10.3133 1.83332C9.54665 1.83332 9.19998 2.71999 9.11332 2.99332C8.99332 3.37999 8.86665 3.76666 8.72665 4.15332C9.20459 4.15029 9.67996 4.08302 10.14 3.95332C10.52 3.81999 11.4733 3.45999 11.4733 2.87999C11.4528 2.58941 11.3205 2.31807 11.1042 2.12292C10.8879 1.92777 10.6045 1.82398 10.3133 1.83332Z" fill="#0C76DA"/>
                            <path d="M7.81352 5.16663C7.04198 5.18022 6.27232 5.08598 5.52686 4.88663C3.86686 4.34663 3.52686 3.49997 3.52686 2.88663C3.52964 2.62758 3.58483 2.37177 3.68909 2.1346C3.79335 1.89744 3.94453 1.68383 4.13352 1.50663C4.55379 1.08385 5.12407 0.84423 5.72019 0.839966C6.84019 0.839966 7.40686 1.88663 7.82686 2.6333C8.0998 3.24539 8.32275 3.87857 8.49352 4.52663C8.51417 4.60017 8.5177 4.67747 8.50383 4.75259C8.48997 4.8277 8.45907 4.89865 8.41352 4.95997C8.36936 5.02189 8.31148 5.07276 8.24441 5.10861C8.17733 5.14446 8.10288 5.16432 8.02686 5.16663H7.81352ZM5.64686 1.8333C5.33027 1.84693 5.03141 1.98322 4.81352 2.2133C4.71849 2.2971 4.64166 2.39949 4.58777 2.51416C4.53387 2.62883 4.50407 2.75333 4.50019 2.87997C4.50019 3.28663 4.99352 3.67997 5.83352 3.9533C6.32367 4.07999 6.8273 4.14714 7.33352 4.1533C7.22569 3.79827 7.09429 3.45083 6.94019 3.1133C6.55352 2.3733 6.18019 1.84663 5.66686 1.8333H5.64686Z" fill="#0C76DA"/>
                            <path d="M14.1668 6.83329V5.99996C14.1668 5.51373 13.9737 5.04741 13.6299 4.7036C13.286 4.35978 12.8197 4.16663 12.3335 4.16663H3.66683C3.1806 4.16663 2.71428 4.35978 2.37047 4.7036C2.02665 5.04741 1.8335 5.51373 1.8335 5.99996V6.83329H14.1668ZM8.50016 7.83329V15.1666H12.3335C12.8197 15.1666 13.286 14.9735 13.6299 14.6297C13.9737 14.2858 14.1668 13.8195 14.1668 13.3333V7.83329H8.50016ZM7.50016 7.83329H1.8335V13.3333C1.8335 13.8195 2.02665 14.2858 2.37047 14.6297C2.71428 14.9735 3.1806 15.1666 3.66683 15.1666H7.50016V7.83329Z" fill="#0C76DA"/>
                        </svg>
                    </div>
                    <div className="text" dangerouslySetInnerHTML={{
                        __html: `You will receive <b>+${voucher.type === 'deposit-cash' ? `$${voucher.bonus}` : `${voucher.bonus}%`}</b> to the next ${voucher.method_prediction ? MethodPrediction.getName(voucher.method_prediction) : 'deposit'}${voucher.minimal_deposit_amount > 0 ? ` from <b>$${voucher.minimal_deposit_amount}</b>` : ''} for activating the «<b>${voucher.code}</b>» promo code`
                    }}></div>
                </div>
            )}

            <div className="methods-list">
                <div className="methods">
                    <div className="list">
                        <Tokens.BTC active={true} onClick={data => onTokenClick(data)} bonus={getMethodPredictionBonus('crypto', deposit_bonus)} />
                        <Tokens.ETH active={true} onClick={data => onTokenClick(data)} bonus={getMethodPredictionBonus('crypto', deposit_bonus)} />
                        <Tokens.LTC active={true} onClick={data => onTokenClick(data)} bonus={getMethodPredictionBonus('crypto', deposit_bonus)} />
                        <Tokens.TRX active={true} onClick={data => onTokenClick(data)} bonus={getMethodPredictionBonus('crypto', deposit_bonus)} />
                        <Tokens.USDT_TRC20 active={true} onClick={data => onTokenClick(data)} bonus={getMethodPredictionBonus('crypto', deposit_bonus)} />
                        <Tokens.USDT_ERC20 active={true} onClick={data => onTokenClick(data)} bonus={getMethodPredictionBonus('crypto', deposit_bonus)} />
                        <Tokens.USDC_ERC20 active={true} onClick={data => onTokenClick(data)} bonus={getMethodPredictionBonus('crypto', deposit_bonus)} />
                        <div className="method-20 back" onClick={e => {
                            dispatch(setTab('deposit'));
                        }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.13 18.31H15.13C17.89 18.31 20.13 16.07 20.13 13.31C20.13 10.55 17.89 8.31 15.13 8.31H4.13" stroke="#DFDFEC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6.43 10.81L3.87 8.25L6.43 5.69" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>


                            Back to wallet
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}